module.exports = __webpack_public_path__ + "static/media/vip_event.61fac65c.svg";